/* ===========================================================
   Lucraa — Landing · Prova humana (depoimento de cliente + nota do fundador)
   ⚠️ O depoimento deve ser de um CLIENTE REAL aprovado antes de publicar — ver
   o aviso em landing.data.ts (DEPOIMENTO). Conteúdo via contrato (landing.data).
   =========================================================== */
import { Icon } from "../../components/ui.jsx";
import { DEPOIMENTO, FUNDADOR } from "./landing.data";

export function LandingDepoimento() {
  return (
    <section id="depoimento" className="lp-section" aria-label="Prova social">
      <div className="lp-wrap lp-dep-grid">
        <figure className="card lp-card lp-dep-quote">
          <span className="lp-dep-mark" aria-hidden="true">
            <Icon name="spark" size={18} color="var(--lucro)" />
          </span>
          <blockquote>{DEPOIMENTO.texto}</blockquote>
          <figcaption>
            <strong>{DEPOIMENTO.autor}</strong> · {DEPOIMENTO.loja}
          </figcaption>
        </figure>
        <div className="lp-dep-founder">
          <span className="label-eyebrow">Por que criamos o Lucraa</span>
          <p>{FUNDADOR.texto}</p>
          <span className="lp-dep-sign">{FUNDADOR.assinatura}</span>
        </div>
      </div>
    </section>
  );
}
